import { render, staticRenderFns } from "./Movement.vue?vue&type=template&id=8244322e&"
import script from "./Movement.vue?vue&type=script&lang=ts&"
export * from "./Movement.vue?vue&type=script&lang=ts&"
import style0 from "./Movement.vue?vue&type=style&index=0&id=8244322e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports